module.exports = __webpack_public_path__ + "img/honor2.d11bda84.png";